/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import Grid from "@material-ui/core/Grid";
import ShareIcon from "@material-ui/icons/Share";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";

import Advertisement from "../../components/Product/Advertisement";
import CategorieComponent from "../../components/Product/CategorieComponent";
import { usePhotoBaseData } from "../../context/PhotoBasicDataContext";
import { useThemeData } from "../../context/ThemeDataContext";
import GeneralButton from "../../components/Buttons";
import GeneralText from "../../components/Fonts";
import Hidden from "@material-ui/core/Hidden";

function Sidebar(props) {
  const { upload_photos } = useThemeData().modules;
  const { font_family, border_radius_2, primary_color_1, background_color_7,primary_color_5 } =
    useThemeData().themeData.site.theme;
  const [showForwardLogin, setShowForwardLogin] = useState(false);
  const [showPhotoUpload, setShowPhotoUpload] = useState(true);
  const [showCategorie, setShowCategorie] = useState(true);

  let location = useLocation();

  const folder_id = props.folder_id;
  const photo_id_prop = props.photo_id;
  const photo_file_name = props.photo_file_name;
  const photo_id_from_url = window.location.pathname.split("/")[3];

  const has_folder_id = localStorage.hasOwnProperty("folder_id");
  const has_photo_id = localStorage.hasOwnProperty("photo_id");
  const has_photo_file_name = localStorage.hasOwnProperty("photo_file_name");

  const keuzeset_id =
    usePhotoBaseData().photoDefaultSettings.default_keuzeset_id;
  const { default_photo_id } = usePhotoBaseData().photoDefaultSettings;

  useEffect(() => {
    if (location.pathname === "/") {
      setShowForwardLogin(false);
      setShowPhotoUpload(false);
    } else {
      setShowCategorie(false);
      localStorage.setItem("folder_id", folder_id);
      localStorage.setItem("photo_id", photo_id_prop);
      localStorage.setItem("photo_file_name", photo_file_name);
      setShowPhotoUpload(upload_photos === "true");
    }
  }, [location, folder_id, photo_id_prop, photo_file_name, upload_photos]);

  useEffect(() => {
    if (
      has_folder_id === true &&
      has_photo_id === true &&
      has_photo_file_name === true
    ) {
      setShowForwardLogin(true);
    }
  }, [has_folder_id, has_photo_id, has_photo_file_name]);

  // Determine selected photo id
  const select_photo_id = photo_id_from_url ?? default_photo_id;

  return (
    <Grid
      container
      direction="row"
      className={`sidebar justify-content-left text-start ${props.className}`}
      style={{
        fontFamily: `${font_family}`,
        // border: "1px solid rgb(217 218 219)",
        borderRadius: `${border_radius_2}`,
      }}
    >
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="col-title"
            style={{
              marginBottom: '15px'
            }}
      >
        <GeneralText
            className="Products top-card app"
            variant="h6"
            style={{
              color: `${primary_color_5}`
            }}
        >
          {props.t("shoppage:Categories")}
        </GeneralText>
      </Grid>
      <Hidden smDown={showCategorie}>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          xl={12}
          className="scroll-body scroll-body-height-categories"
                style={{
                  fontFamily: `${font_family}`,
                  border: "1px solid rgb(217 218 219)",
                  borderRadius: `${border_radius_2}`,
                }}>
          <CategorieComponent
            {...props}
            categoryData={props.categoryData}
            type="sidebar"
            select_photo_id={select_photo_id}
          />
        </Grid>
        {showForwardLogin && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              className="col-title"
            >
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="text-start">
                <GeneralButton
                  onClick={() =>
                    props.historyHome !== undefined
                      ? props.historyHome.push("/forward-login")
                      : props.historyShop.push("/forward-login")
                  }
                  style={{
                    marginBottom: `40px`,
                  }}
                  className="btn btn-secondary btn-bttm-margin width-fill"
                  type="button"
                  name="share"
                  startIcon={<ShareIcon color="inherit" />}
                >
                  {props.t("shoppage:Share photo")}
                </GeneralButton>
              </div>
            </Grid>
          </>
        )}
        {showPhotoUpload && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              style={{
                backgroundColor: `${background_color_7}`,
                border: `1px solid ${background_color_7}`,
                borderRadius: `${border_radius_2} ${border_radius_2} 0px 0px`,
                color: `${primary_color_1}`,
              }}
              className="col-title"
            >
              <GeneralText className="sidebar-title" variant="h6">
                {props.t("shoppage:Upload photo")}
              </GeneralText>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="text-start">
                <GeneralButton
                  onClick={() =>
                    props.historyHome !== undefined
                      ? props.historyHome.push("/forward-login")
                      : props.historyShop.push({
                          pathname: "/upload-photo",
                          state: {
                            type: "sidebar",
                          },
                        })
                  }
                  style={{
                    marginBottom: `40px`,
                    marginTop: `40px`,
                  }}
                  className="btn btn-secondary btn-bttm-margin width-fill"
                  type="button"
                  name="upload"
                  startIcon={<AddPhotoAlternateIcon color="inherit" />}
                >
                  {props.t("shoppage:Upload photo button")}
                </GeneralButton>
              </div>
            </Grid>
          </>
        )}
      </Hidden>
      <Advertisement
          {...props}
          select_photo={props.select_photo}
          keuzeset_id={keuzeset_id}
      />
    </Grid>
  );
}

export default React.memo(withTranslation(["message", "shoppage"])(Sidebar));
